import useGetCategory from './useGetCategory'
export default useGetCategory
